import { gql } from '@apollo/client';

import client from '../services/graphql';

export const TREE_TEST_FRAGMENT = gql`
  fragment TreeTestFragment on TreeTestNode {
    id
    label
    parentId
    projectId
    order
  }
`;

export const QUESTION_OPTIONS_FRAGMENT = gql`
  fragment QuestionOptionsFragment on QuestionOption {
    id
    label
  }
`;

export const FOLLOW_UP_QUESTION_FRAGMENT = gql`
  fragment FollowUpQuestionsFragment on Question {
      id
      label
      questionType
      leftLabel
      rightLabel
      questionOrder
      randomize
      questionOptions {
        ...QuestionOptionsFragment
      }
    }
    ${QUESTION_OPTIONS_FRAGMENT}
`;

export const QUESTION_FRAGMENT = gql`
  fragment QuestionFragment on Question {
    id
    label
    questionType
    questionOrder
    followUpQuestions {
      ...FollowUpQuestionsFragment
    }
  }
  ${FOLLOW_UP_QUESTION_FRAGMENT}
`;

export const SURVEY_FRAGMENT = gql`
  fragment SurveyFragment on Survey {
    id
    surveyType
    questions {
      ...QuestionFragment
    }
  }
  ${QUESTION_FRAGMENT}
`;

export const PROJECT_WITH_TREE_TEST_AND_SURVEY = gql`
  query project($id: ID!) {
      project(id: $id) {
      id
      thankYouTitle
      thankYouContent
      thankYouRedirectLink
      sortRandom
      instructionsTitle
      instructionsContent
      hasMrId
      surveys {
        id
        surveyType
        questions(questionOrder: "asc") {
          ...QuestionFragment
        }
      }
      treeTestNodes {
        ...TreeTestFragment
      }
    }
  }
  ${TREE_TEST_FRAGMENT}
  ${QUESTION_FRAGMENT}
`;

export const PROJECT_INSTRUCTIONS = gql`
  query project($id: ID!) {
      project(id: $id) {
      id
      instructionsContent
      instructionsTitle
    }
  }
`;

export const TEST_SESSION_ANSWERS_BY_TEST_SESSION_ID = gql`
  query TestSessionAnswers($testSessionId: ID!) {
    testSessionAnswers(testSessionId: $testSessionId) {
        id
        question {
          id
          label
          questionOrder
        }
        treeTestPath
        treeTestResult
      }
    }
`;

export const saveTestSessionAnswers = async (attributes) => {
  const query = gql`
    mutation CreateTestSessionAnswer($attributes: [TestSessionAnswerAttributes!]!) {
        saveTestSessionAnswer(attributes: $attributes) {
          testSessionAnswers {
            id
            question {
              id
              label
              questionType
              leftLabel
              rightLabel
              questionOrder
            }
          }
        }
      }
  `;

  const data = await client.getClient().mutate({
    mutation: query,
    variables: attributes,
  });

  if (data.error) {
    throw new Error('GraphQL request resulted in errors.');
  }

  return data?.data;
};
